// extracted by mini-css-extract-plugin
export var originalPrice = "_vq-0";